// import PopupContainer from "../popupContainer/popupContainer.vue";//不用了
import Vue from 'vue'
import Component from 'vue-class-component'
import chooseStyle from "../chooseStyle/chooseStyle.vue"
import chooseSpeed from "../chooseSpeed/chooseSpeed.vue"


@Component({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => [],
    },
    speedValue:{},
    speakerStyleValue: {
      type: Number
    },
    // currSpeaker:Object,
    speakerEmotionCacheVOList:Array,
  },
  watch: {
    visible: {
      handler(val) {
        this.show = val;//弹框显示隐藏
        this.currentSpeakerWithMood = null
        if (this.visible) {
          this.selectSpeedValue = this.$props.speedValue;
          this.selectedStyleValue = this.$props.speakerStyleValue;
          console.log('---选择风格和语速',this.$props.speakerStyleValue)
          // const index = this.speakerEmotionCacheVOList.findIndex(
          //   (item) => item.speakerId === this.speakerStyleValue
          // );
          // if (index === -1 && this.options.length > 0) {
          //   this.selectedStyleValue = this.options[0].speakerId;
          // } else {
          //   this.selectedStyleValue = this.speakerStyleValue;
          // }
        }
      },
      immediate: true
    }
  },
  components: {
    // PopupContainer,
    chooseStyle,
    chooseSpeed
  }
})
//参考style-select-popper
export default class StyleSpeedPopup extends Vue{
  show   = false;
  selectedStyleValue = "";//选择的风格
  selectedStyleName ="默认";//选择的风格名称
  selectSpeedValue ="";
  currentSpeakerWithMood = null
  mounted(){
  //  this.$props.speakerStyleValue;
   console.log('---选择风格时上一个页面传入的发音人Id',this.$props.speakerStyleValue)
  }
  beforeDestroy() {
    this.closePopup();
  }
  closePopup() {
    //声音播放关闭
    if(this.$refs.chooseStyle) (this.$refs.chooseStyle as any).stopPlay();
    this.$emit('close')
  }
  //确认使用风格与倍速
  confirmStyleAndSpeed(){
    console.log('---确认使用风格与倍速',this.selectedStyleValue,this.selectSpeedValue,this);
    //声音播放关闭
    (this.$refs.chooseStyle as any).stopPlay();
    if (this.currentSpeakerWithMood) {
      this.$store.state.currSpeaker.defaultSpeaker = this.currentSpeakerWithMood
    }
    this.$emit('confirm',this.selectedStyleValue,this.selectedStyleName,this.selectSpeedValue)
  }
  pickSpeakerStyle(speakerWithMood){
    this.currentSpeakerWithMood = speakerWithMood
    this.selectedStyleValue = speakerWithMood.speakerId//speakerId
    this.selectedStyleName =  speakerWithMood.name.split("|")[1]||'默认';//speakerName
  }
  pickSpeed(speed){
    this.selectSpeedValue = speed;
  }
}